import { makeStyles } from '@material-ui/styles'

const useDetailStyles = makeStyles(theme => ({
  page: {
    marginBottom: theme.spacing(8),
  },
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1),
      gap: theme.spacing(2.5),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  headerCopy: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.25,
    color: '#00205B',
  },
  meta: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionEyebrow: {
    margin: 0,
    marginBottom: theme.spacing(1),
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  sectionCard: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(2.5, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  bodyText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.6,
    color: '#172024',
    whiteSpace: 'pre-wrap',
  },
  planSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  planActivityGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  activityHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  activityTitleGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  activityHeading: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.25,
    color: '#00205B',
  },
  videoWrapper: {
    marginTop: theme.spacing(1.5),
  },
  detailVideo: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0,
    overflow: 'hidden',
    borderRadius: 8,
    '& > iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 0,
    },
  },
}))

export default useDetailStyles
